"use client";
import { usePathname } from "next/navigation";
import React, { useState, useEffect } from "react";
import { getCurrentTime } from "@centisystems/lib/utils";
import { Badge } from "../atoms/badge";
interface DateTimeProps {
  className?: string;
}
export function DateTime({ className }: DateTimeProps) {
  const pathname = usePathname();
  const minInMilliseconds = 60000;
  const [currentDateTime, setCurrentDateTime] = useState(getCurrentTime());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(getCurrentTime());
    }, minInMilliseconds);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Badge
      color={pathname?.startsWith("/procure") ? "zinc" : "primary"}
      suppressHydrationWarning
      className={`!normal-case ${className}`}>
      {currentDateTime}
    </Badge>
  );
}
